import './resultListScreen.scss';
import React, {useCallback, useEffect, useState} from "react";
import ButtonComponent from "../../../shared/components/core/button/ButtonComponent";
import ResultListTableComponent from "./result-list-table/ResultListTableComponent";
import DialogComponent from '../../../shared/components/dialog/dialogComponent';
import FileDragAndDropComponent from '../../../shared/components/file-drag-n-drop/FileDragAndDropComponent';
import AddIcon from '@mui/icons-material/Add';
import {CommonService} from "../../../shared/services";
import {IAPIResponseType} from '../../../shared/models/api.model';
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {setCurrentNavParams, setSideMenuView} from "../../../store/actions/header.action";
import SearchComponent from "../../../shared/components/search/SearchComponent";
import {IRootReducerState} from "../../../store/reducers";
import AutoCompleteDropdownComponent
    from "../../../shared/components/core/auto-complete-dropdown/autoCompleteDropdownComponent";
import FolderIcon from "@mui/icons-material/Folder";
import DrawerComponent from "../../../shared/components/drawer/drawerComponent";
import TestPanelResultTeamplateDownloadComponent
    from "../test-panel-result-teamplate-download/TestPanelResultTeamplateDownloadComponent";
import commonService from "../../../shared/services/common.service";
import {AttachFile} from "@mui/icons-material";
import ChipComponent from "../../../shared/components/chip/ChipComponent";
import TabsWrapperComponent, {
    TabComponent,
    TabContentComponent,
    TabsComponent
} from "../../../shared/components/tabs/tabsComponent";
import useFetch from "../../../shared/hooks/useFetch";
import {APIConfig} from "../../../constants";

const MANUAL_UPLOAD_TAB = "manual-upload";
const UPLOAD_FROM_LAB_OS = "upload-from-lab-os";


const ResultListScreen = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<'manual-upload' | 'upload-from-lab-os'>(MANUAL_UPLOAD_TAB);
    const [isTemplateDrawerOpen, setIsTemplateDrawerOpen] = React.useState<boolean>(false);
    const [isUploadXlsDialogOpen, showUploadXlsDialogOpen] = useState<boolean>(false);
    const [resultAttachmentFile, setResultAttachmentFile] = useState<File | undefined>(undefined);
    const [isAttachmentBeingUploaded, setIsAttachmentBeingUploaded] = useState<boolean>(false);
    const [testId, setTestId] = React.useState<any>(undefined);
    const [resultJson, setResultJson] = useState<any>(undefined);
    const [labOsResultLogId, setLabOsResultLogId] = useState(undefined);
    const dispatch = useDispatch();
    const {queryParamData} = useSelector((state: IRootReducerState) => state.stateManagement);
    const {currentUser} = useSelector((state: IRootReducerState) => state.account);
    const {testListLite} = useSelector((state: IRootReducerState) => state.staticData);
    const [filterData, setFilterData] = useState<any>({
        search: '',
    });

    const {
        response: labOsResultList = [],
        loading: isLabOsResultLoading,
        fetchData: fetchLabOsResultList
    } = useFetch<any>();

    const getLabOsResultList = (testId: string | number) => {
        fetchLabOsResultList({
            url: APIConfig.GET_LAB_OS_RESULT_LIST.URL(testId),
            method: APIConfig.GET_LAB_OS_RESULT_LIST.METHOD
        })
    }

    useEffect(() => {
        dispatch(setCurrentNavParams("Result", "Result"));
        dispatch(setSideMenuView('default'));
    }, [dispatch]);

    const handleResultFilesDrop = useCallback((files: any) => {
        const file = files[0];
        setResultAttachmentFile(file);
    }, []);

    const resetUploadFileForm = useCallback(() => {
        setTestId(undefined);
        setResultAttachmentFile(undefined);
        setResultJson(undefined);
        setLabOsResultLogId(undefined);
    }, []);
    const handleActiveTabChange = useCallback((value: 'manual-upload' | 'upload-from-lab-os') => {
        setActiveTab(value);
        resetUploadFileForm();
    }, [resetUploadFileForm])

    const openUploadXlsDialogComponent = () => {
        showUploadXlsDialogOpen(true);
    }
    const closeUploadXlsDialogComponent = useCallback(() => {
        resetUploadFileForm()
        showUploadXlsDialogOpen(false);
    }, [resetUploadFileForm])

    const uploadXlsResult = useCallback(() => {
        const formData = new FormData();
        if (resultAttachmentFile) {
            formData.append('file', resultAttachmentFile);
        }
        formData.append('testId', testId?.id);
        if (activeTab === 'upload-from-lab-os' && !labOsResultLogId) {
            CommonService._alert.showToast('Lab os result log id not found', "error");
            return;
        }
        setIsAttachmentBeingUploaded(true);
        CommonService._result.uploadResultXlsx(formData)
            .then((response: IAPIResponseType<any>) => {
                if (response.success) {
                    closeUploadXlsDialogComponent();
                    setIsAttachmentBeingUploaded(false);
                    navigate(CommonService._routeConfig.ResultPreviewRoute(response.data.id + CommonService.setUrlSearchParams({
                        labOsResultLogId: labOsResultLogId || ''
                    })));
                }
            })
            .catch((error: any) => {
                CommonService._alert.showToast(error?.error || 'Error uploading order attachment', "error");
                setIsAttachmentBeingUploaded(false);
            })

    }, [resultAttachmentFile, testId, closeUploadXlsDialogComponent, navigate, activeTab, labOsResultLogId]);


    const handleSearch = useCallback((value: string) => {
        setFilterData((prevState: any) => ({
            ...prevState,
            search: value
        }));
        CommonService.setQueryParam('search', value);
    }, []);

    useEffect(() => {
        if (queryParamData) {
            setFilterData((prevState: any) => ({
                ...prevState,
                search: queryParamData.search || '',
            }));
        }
    }, [queryParamData]);

    return (
        <div className="result-list-screen screen">
            <div className={"screen-content-wrapper"}>
                <div className="page-data-wrapper">
                    <div className="page-options">
                        <div className="page-search">
                            <SearchComponent
                                label={"Search Result"}
                                id="search_input"
                                placeholder={""}
                                value={filterData.search}
                                onChange={handleSearch}
                            />
                        </div>
                        <div className="page-extra-options">
                            {commonService.checkAccess("Result", "panelUploadXLS", currentUser?.userAccessModules)
                                &&
                                <>
                                    <ButtonComponent
                                        type="button"
                                        id="template_btn"
                                        color={"secondary"}
                                        variant={"outlined"}
                                        fullWidth={false}
                                        handleClick={() => {
                                            setIsTemplateDrawerOpen(true)
                                        }}
                                        startIcon={<FolderIcon/>}
                                    >
                                        Download Templates
                                    </ButtonComponent>


                                    <ButtonComponent
                                        handleClick={openUploadXlsDialogComponent}
                                        type="button"
                                        color={"primary"}
                                        variant={"contained"}
                                        id="import_xls_file_button"
                                        startIcon={<AddIcon/>}
                                    >
                                        Upload XLS File
                                    </ButtonComponent>
                                </>
                            }
                        </div>
                    </div>
                    <>
                        <ResultListTableComponent filterData={filterData}/>
                    </>
                </div>
            </div>
            <DrawerComponent open={isTemplateDrawerOpen}
                             className={"drawer-wrapper"}
                             closeOnBackDropClick={true}
                             closeOnEsc={true}
                             title={""}
                             onClose={() => setIsTemplateDrawerOpen(false)}
            >
                <>
                    <TestPanelResultTeamplateDownloadComponent onTemplateDrawerClose={() => {
                        setIsTemplateDrawerOpen(false)
                    }}/>
                </>
            </DrawerComponent>
            <DialogComponent open={isUploadXlsDialogOpen}
                             onClose={closeUploadXlsDialogComponent}
                             title="Upload the XLS or CSV file for generating the results"
                             isShowCancel={false}
                             maxWidth={"sm"}>
                <TabsWrapperComponent>
                    <TabsComponent value={activeTab}
                                   onUpdate={(e: any, v: any) => {
                                       handleActiveTabChange(v)
                                   }}
                                   variant={"fullWidth"}>
                        <TabComponent label={"Manual Upload"} value={MANUAL_UPLOAD_TAB}/>
                        <TabComponent label={"Upload from lab os"} value={UPLOAD_FROM_LAB_OS}/>
                    </TabsComponent>
                    <TabContentComponent value={MANUAL_UPLOAD_TAB} selectedTab={activeTab}>
                        <div className="file-upload-wrapper mrg-top-10">
                            <AutoCompleteDropdownComponent
                                fullWidth={true}
                                name={'panel'}
                                label={'Select Test'}
                                required={true}
                                multiple={false}
                                data={testListLite}
                                valueKey={'id'}
                                value={testId}
                                onSelectUpdate={(value: any) => {
                                    setTestId(value)
                                }}
                                getOptionLabel={(option => (option.name) || '')}
                            />
                            {
                                !resultAttachmentFile &&
                                <FileDragAndDropComponent onFilesDrop={handleResultFilesDrop}
                                                          acceptedFileTypes={
                                                              {
                                                                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [],
                                                                  'text/csv': []
                                                              }
                                                          }
                                                          fileSizeLimitText={'XLS or CSV smaller than 5MB'}/>
                            }
                            <div className="file-upload-selected-file-action-buttons-wrapper">
                                <div className="file-upload-selected-files-details">
                                    {resultAttachmentFile &&
                                        <ChipComponent
                                            label={resultAttachmentFile?.name}
                                            onDelete={() => {
                                                setResultAttachmentFile(undefined);
                                            }}
                                            icon={<AttachFile/>}
                                            className={'attachment-chip-item'}
                                        />
                                    }
                                    {/*// <FeedbackComponent>{resultAttachmentFile?.name}</FeedbackComponent>}*/}
                                </div>
                                <div className="file-upload-action-buttons">
                                    <ButtonComponent variant={"outlined"}
                                                     handleClick={closeUploadXlsDialogComponent}
                                                     disabled={isAttachmentBeingUploaded}
                                                     fullWidth={true}
                                                     color={"primary"}>
                                        Cancel
                                    </ButtonComponent>&nbsp;
                                    <ButtonComponent variant={"contained"}
                                                     handleClick={uploadXlsResult}
                                                     disabled={isAttachmentBeingUploaded || !resultAttachmentFile || !testId}
                                                     isLoading={isAttachmentBeingUploaded}
                                                     fullWidth={true}
                                                     color={"primary"}
                                    >
                                        Proceed
                                    </ButtonComponent>
                                </div>
                            </div>
                        </div>
                    </TabContentComponent>
                    <TabContentComponent value={UPLOAD_FROM_LAB_OS} selectedTab={activeTab}>
                        <div className="file-upload-wrapper mrg-top-10">
                            <AutoCompleteDropdownComponent
                                fullWidth={true}
                                name={'panel'}
                                label={'Select Test'}
                                required={true}
                                multiple={false}
                                data={testListLite}
                                valueKey={'id'}
                                value={testId}
                                onSelectUpdate={(value: any) => {
                                    setTestId(value)
                                    getLabOsResultList(value?.id)
                                    setResultAttachmentFile(undefined)
                                    setResultJson(undefined)
                                }}
                                getOptionLabel={(option => (option.name) || '')}
                            />
                            <AutoCompleteDropdownComponent
                                fullWidth={true}
                                name={'labs result'}
                                label={'Select LabOS Result'}
                                required={true}
                                multiple={false}
                                data={labOsResultList || []}
                                isDataLoading={isLabOsResultLoading}
                                valueKey={'sampleJson'}
                                value={resultJson}
                                onSelectUpdate={(value: any) => {
                                    setResultJson(value);
                                    const file = CommonService.convertJsonToCsv(value?.sampleJson, "file") as File;
                                    setResultAttachmentFile(file);
                                    setLabOsResultLogId(value?.id)
                                }}
                                getOptionLabel={(option) => {
                                    const {testCode = '', plateNo = '', createdAt, id=''} = option;

                                    if (!createdAt) return '';

                                    const formattedDate = CommonService.formatDate(createdAt, "MM/DD/YYYY hh:mm:ss A");
                                    const label = `${testCode ? `${testCode}_` : ''}${plateNo} (${formattedDate}) ${id}`;

                                    return label;
                                }}
                            />
                            <div className="file-upload-selected-file-action-buttons-wrapper">
                                <div className="file-upload-action-buttons">
                                    <ButtonComponent variant={"outlined"}
                                                     handleClick={closeUploadXlsDialogComponent}
                                                     disabled={isAttachmentBeingUploaded}
                                                     fullWidth={true}
                                                     color={"primary"}>
                                        Cancel
                                    </ButtonComponent>&nbsp;
                                    <ButtonComponent variant={"contained"}
                                                     handleClick={uploadXlsResult}
                                                     disabled={isAttachmentBeingUploaded || !resultAttachmentFile || !testId}
                                                     isLoading={isAttachmentBeingUploaded}
                                                     fullWidth={true}
                                                     color={"primary"}
                                    >
                                        Proceed
                                    </ButtonComponent>
                                </div>
                            </div>
                        </div>
                    </TabContentComponent>
                </TabsWrapperComponent>
            </DialogComponent>
        </div>
    )
};
export default ResultListScreen;
